import React, {useEffect, useMemo, useState} from 'react';
import styles from "./MissionParticipantsList.module.scss";
import {DataGrid} from "@mui/x-data-grid";
import moment from "moment";
import {hasValue} from "../../helpers/helperFunctions";
import Modal, {MODAL_SIZE_FULL, MODAL_SIZE_LARGE} from "../../Components/Modal/Modal";
import { ReactComponent as CaretDown } from '../../images/svg/CaretDownNew.svg';
import classNames from "classnames";
import {PROD_API_URL} from "../../constants/constants";
import toast from "react-hot-toast";
import {errorToast, successToast} from "../../helpers/toastCSS";

const TasksColums = [
    {field: 'solanaWallet', headerName: 'Wallet', flex: 2},
    {field: 'username', headerName: 'Username', flex: 1},
    {
        field: 'profileImage',
        headerName: 'Profile Image',
        width: 100,
        renderCell: (params) => (
            params.value ? <img className={styles.rankImage} src={params.value} alt="profileImage"/> : ''
        )
    },
    {field: 'status', headerName: 'Mission Status', width: 140},
    {field: 'taskStatus', headerName: 'Tasks Status', width: 180},
    {field: 'failedTask', headerName: 'Task Failure', width: 500},
    {
        field: 'updatedAt',
        headerName: 'Last Updated',
        width: 200,
        renderCell: (params) => (
            moment.unix(params.value / 1000).format('YYYY-MM-DD , hh:mm')
        )
    },
];

const MissionParticipantsList = (props) => {
  const {
    mission
  } = props;

  const participants = mission?.participants;

  const [selectedData, setSelectedData] = useState();

    const completeSubTask = async (subtaskIndex, task) => {
        const body = {
            missionId: selectedData.missionId,
            solanaWallet: selectedData.solanaWallet,
            step: task.step,
            subtaskIndex: subtaskIndex,
        }

        await fetch(PROD_API_URL + "/mission/forceCompleteSubTask", {
            "method": "POST",
            "headers": {"content-type": "application/json", "accept": "*"},
            "body": JSON.stringify(body)
        }).then((res)=>{
                if (res.ok) {
                    toast('Subtask Completed!', successToast);
                    setSelectedData(prev => ({
                        ...prev, tasks: prev.tasks.map(t => {
                            if (t.step === task.step) {
                                const allSubTasksCompleted = t.subtasks.filter((subtask, index) => subtask.completed !== true || index === subtaskIndex).length === 0;
                                return {
                                    ...t,
                                    status: allSubTasksCompleted ? 'Completed' : t.status,
                                    subtasks: t.subtasks.map((subtask, i) => {
                                        if (i === subtaskIndex) {
                                            return {...subtask, completed: true, failureReason: ''};
                                        }
                                        return subtask;
                                    })
                                }
                            }
                            return t;
                        })
                    }))
                } else {
                    toast('Error completing subtask', errorToast);
                }
            });
    }


    const formatedRows = useMemo(() => {
      if (!participants) return [];
    return participants.map(row => {
        const totalTasks = row.tasks.length;
        const completedTasks = row.tasks.filter(task => task.status === 'Completed').length;
        const taskStatus = `Completed: ${completedTasks}/${totalTasks}`;
        const failedTask = row.tasks.find(task => task.status === 'Failed');
        let failedTaskText = '';
        if (failedTask) {
            const failedSubTasks = failedTask?.subtasks.filter(task => task.completed === false && hasValue(task.failureReason));
            failedTaskText = 'Failed task: ' + mission.tasks[failedTask.step - 1].name + ' - ' + failedSubTasks.length + ' subtasks failed';
        }


      return {
        ...row,
        taskStatus,
        failedTask: failedTaskText,
      }
    })
  }, [participants]);


  return (
      <div className={styles.missionParticipantsContainer}>
          <div className={styles.tableContainer}>
              {formatedRows &&
                  <DataGrid
                      rows={formatedRows}
                      onCellDoubleClick={(params) => setSelectedData(params.row)}
                      columns={TasksColums}
                  />}
          </div>
          <Modal
              show={hasValue(selectedData)}
              setShow={() => setSelectedData(undefined)}
              type={MODAL_SIZE_FULL}
              header={"Participant Details - " + selectedData?.solanaWallet}
          >
              {selectedData && <div className={styles.participantDetailsContainer}>
                  <div className={styles.participantDetailsRow}>
                      <span className={styles.participantDetailsLabel}>{selectedData?.username}</span>
                      {selectedData.profileImage && <img className={styles.rankImage} src={selectedData.profileImage} alt="profileImage"/>}
                  </div>
                  <span className={styles.participantDetailsLabel}>Mission Status: {selectedData?.status}</span>
                  <div className={styles.participantTasksContainer}>
                      {selectedData.tasks.map(task => {
                          return (
                            <ParticipantTaskRow key={task.step} task={task} completeSubTask={completeSubTask}/>
                          )
                      })}
                  </div>
                  <span>Last Updated: {moment.unix(selectedData.updatedAt / 1000).format('YYYY-MM-DD , hh:mm')}</span>
              </div>}
          </Modal>
      </div>
  )
}

const ParticipantTaskRow = (props) => {
    const {
        task,
        completeSubTask,
    } = props;

    const [open, setOpen] = useState(false);

    const subTaskRender = () => {
        return (task.subtasks.map((subtask, index) => {
                return (
                    <div key={subtask.label} className={styles.participantSubTaskRow}>
                        <span>Subtask: {subtask.label}</span>
                        <span>Completed: {subtask.completed ? 'Yes' : 'No'}</span>
                        <span>Failure Reason: {subtask.failureReason}</span>
                        <span>Task Item: {subtask.taskItem}</span>
                        {subtask.completed !== true ?
                            <div className={styles.completeSubTaskButton} onClick={() => completeSubTask(index, task)}>
                                COMPLETE SUBTASK
                            </div> : <></>}
                    </div>
                )
        }))
    }

    const totalSubTasks = task.subtasks.length;
    const completedSubTasks = task.subtasks.filter(subtask => subtask.completed).length;
    const failedSubTasks = task.subtasks.filter(subtask => !subtask.completed).length;
    const subTaskStatus = `Total: ${totalSubTasks} / Completed: ${completedSubTasks} / Failed: ${failedSubTasks}`;

    const statusClassName = classNames({
        [styles.statusFailed]: task.status === 'Failed',
        [styles.statusCompleted]: task.status === 'Completed',
        [styles.statusInProgress]: task.status === 'Started',

    })

    return (
        <div className={styles.participantTaskRowContainer} key={task.step}>
            <div className={open ? styles.participantTaskRowOpen : styles.participantTaskRow} onClick={() => setOpen(!open)}>
                <span>Step: {task.step}</span>
                <span>Status: <span className={statusClassName}>{task.status}</span></span>
                <span>Subtask Status: {subTaskStatus}</span>
                <span>Timestamp: {moment.unix(task.timestamp).format('YYYY-MM-DD , hh:mm')}</span>
                <CaretDown className={open ? styles.caretIconRotated : styles.caretIcon} />
            </div>
            <div className={open ? styles.participantSubTaskContainerOpen : styles.participantSubTaskContainer}>
                {subTaskRender()}
            </div>
        </div>

    )
}

export default MissionParticipantsList;
